import { useState } from "react";
import { isMobile } from "react-device-detect";

import Step1 from "./steps/step-1/step-1";
import Step2 from "./steps/step-2/step-2";
import Step3 from "./steps/step-3/step-3";
import api from "../../../services/api";
import Loading from "../../../components/loading/loading";
import { useNavigate } from "react-router-dom";
import "./register-page.scss";

import Swal from "sweetalert2";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 10000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.onmouseenter = Swal.stopTimer;
    toast.onmouseleave = Swal.resumeTimer;
  },
});

function RegisterPage() {
  const [loading, setLoading] = useState(false);
  const [actualStep, setActualStep] = useState(1);
  const [formData, setFormData] = useState({});

  const navigate = useNavigate();

  function showFormStep() {
    if (actualStep === 1) {
      return <Step1 nextStep={nextStep} />;
    } else if (actualStep === 2) {
      return <Step2 prevStep={prevStep} nextStep={nextStep} />;
    } else if (actualStep === 3) {
      return <Step3 prevStep={prevStep} register={register} />;
    }
  }

  function nextStep(newFormData) {
    setFormData((oldData) => {
      return {
        ...oldData,
        ...newFormData,
      };
    });
    setActualStep(actualStep + 1);
  }

  function prevStep() {
    setActualStep(actualStep - 1);
  }

  async function register() {
    const payload = {
      name: formData.nome,
      email: formData.email,
      password: formData.cpf,
      password_confirmation: formData.cpf,
      phone: formData.telefone,
      cpf: formData.cpf,
      instagram: formData.instagram,
      zip_code: formData.cep,
      street: formData.endereco,
      district: formData.bairro,
      state: formData.estado,
      city: formData.cidade,
      number: formData.numero,
      complement: formData.complemento,
    };
    try {
      setLoading(true);
      const response = await api.post("register", payload);
      console.log("Response register", response);
      Toast.fire({
        icon: "success",
        title: `Sua conta foi criada com sucesso! Até você mudar, seu CPF será a sua senha!`,
      });
      navigate("/login");
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="register-page">
      {loading ? <Loading /> : null}
      <div className="container-fluid px-4">
        <div className="form-content">
          <div
            className={`d-flex ${
              isMobile ? "flex-column gap-2" : "gap-4"
            } align-items-center text-center titles`}
          >
            <h1>Faça seu cadastro</h1>
            <div
              className="diviser"
              style={isMobile ? { display: "none" } : { display: "block" }}
            ></div>
            <h2>Preencha seus dados para realizar o cadastro.</h2>
          </div>
          <div className="d-flex steps">
            <div
              className={`d-flex align-items-center step
                ${actualStep === 1 ? "actual" : ""}
                ${actualStep > 1 ? "active" : ""}
              `}
            >
              <div className="d-flex justify-content-center align-items-center number">
                1
              </div>
              <h4>Dados pessoais</h4>
            </div>
            <div
              className={`d-flex align-items-center step
                ${actualStep === 2 ? "actual" : ""}
                ${actualStep > 2 ? "active" : ""}
              `}
            >
              <div className="d-flex justify-content-center align-items-center number">
                2
              </div>
              <h4>Localização</h4>
            </div>
            <div
              className={`d-flex align-items-center step ${
                actualStep === 3 ? "actual" : ""
              }`}
            >
              <div className="d-flex justify-content-center align-items-center number">
                3
              </div>
              <h4>Contrato</h4>
            </div>
          </div>
          <div className="form mt-5">{showFormStep()}</div>
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;
